<template>
  <svg viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.5 5.2H9C9 2.9304 6.93375 1.8952 5.25 1.6568V0H3.75V1.6568C2.06625 1.8952 0 2.9304 0 5.2C0 7.3648 1.9995 8.4904 3.75 8.744V12.72C2.664 12.5192 1.5 11.9008 1.5 10.8H0C0 12.8712 1.81875 14.0952 3.75 14.3488V16H5.25V14.344C6.93375 14.1056 9 13.0696 9 10.8C9 8.5304 6.93375 7.4952 5.25 7.2568V3.28C6.2475 3.4712 7.5 4.0328 7.5 5.2ZM1.5 5.2C1.5 4.0328 2.7525 3.4712 3.75 3.28V7.1192C2.72175 6.9168 1.5 6.3176 1.5 5.2ZM7.5 10.8C7.5 11.9672 6.2475 12.5288 5.25 12.72V8.88C6.2475 9.0712 7.5 9.6328 7.5 10.8Z"
      fill="black"
    />
  </svg>
</template>
